import { z } from "zod";

export const BookingCallAuthCheckRequestSchema = z.object({
    email: z.email(),
});

export type BookingCallAuthCheckRequest = z.infer<typeof BookingCallAuthCheckRequestSchema>;

export const BookingCallAuthCheckResponseSchema = z.object({
    email_exists: z.boolean(),
    requires_login: z.boolean(),
    user_type: z.enum(["client", "expert", "admin"]).nullable(),
});

export type BookingCallAuthCheckResponse = z.infer<typeof BookingCallAuthCheckResponseSchema>;

export const SubmitBookingCallLeadRequestSchema = z.object({
    expert_id: z.number().int().positive(),
    name: z.string().min(1).max(255).optional(),
    email: z.email().max(255).optional(),
    company_name: z.string().min(1).max(255).optional(),
    company_website: z.string().url().max(500).optional(),
});

export type SubmitBookingCallLeadRequest = z.infer<typeof SubmitBookingCallLeadRequestSchema>;

export const SubmitBookingCallLeadResponseSchema = z.object({
    lead_id: z.number().int().positive(),
    project_id: z.number().int().positive().nullable().optional(),
    expert_id: z.number().int().positive(),
    booking_call_url: z.string().nullable().optional(),
    is_new_account: z.boolean(),
});

export type SubmitBookingCallLeadResponse = z.infer<typeof SubmitBookingCallLeadResponseSchema>;
